import { Window } from './Window';

export class CircularWindow extends Window {
  constructor(renderer, parent, def) {
    super(renderer, parent, def);
  }

  _create2DVertices(width, height, adjust, geometryData) {
    return create2DVertices(width, height, adjust);
  }

  _transformDimensionsToRect(dimensions, width, height, geometryData) {
    return transformDimensionsToRect(dimensions, width, height);
  }
}

export function transformDimensionsToRect(dimensions, width, height) {
  return {
    left: dimensions.VSP,
    right: dimensions.HSP,
    top: dimensions.OVP,
    bottom: dimensions.UNP,
  };
}

const segmentCount = 256;
export function create2DVertices(width, height, adjust) {
  const v = [];
  const angleStep = (-Math.PI * 2) / segmentCount;
  const cw = width + adjust.VSP + adjust.HSP;
  const ch = height + adjust.OVP + adjust.UNP;

  let angle = 0;
  for (let i = 0; i < segmentCount; i++) {
    const x = (Math.cos(angle) / 2) * cw + (adjust.HSP - adjust.VSP) / 2;
    const y = (Math.sin(angle) / 2) * ch + (adjust.OVP - adjust.UNP) / 2;
    v.push(x, y);
    angle += angleStep;
  }

  return v;
}
